import Vue from 'vue'
import createRepository from "./repository"
import vuetify from '@/plugins/vuetify'
import App from './App'
import router from './router'
import AppMixins from "./seedwork/mixins"
import VueKinesis from "vue-kinesis";

import AOS from 'aos'
import "aos/dist/aos.css"

const config = {
  repository: createRepository(),
}

Vue.use(AppMixins);
Vue.use(vuetify);
Vue.use(VueKinesis);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  $repository: config.repository,
  router,
  vuetify,
  components: { App },
  template: '<App/>',
  created() {
    AOS.init({
      delay: 500,
      duration: 1000,
    });
  },
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js